export const SEMESTERS = Array.from({ length: 30 }, (_, i) => i + 1)
